/* eslint-disable no-plusplus */
import { v4 as uuidv4 } from 'uuid';

const specialCharacters = ['!', '@', '#', '$', '-', '^', '&', '*'];

const tripleRepeatingCharacterRegex = /(.)\1\1/;

const MAX_REPEATING_CHARACTERS = 2;

const getRandomNumber = (): number => {
  // @ts-ignore
  const crypto = window.crypto || window.msCrypto;
  const array = new Uint32Array(1);
  return crypto.getRandomValues(array)[0];
};

export const passwordGenerate = () => {
  const originalPassword = uuidv4().slice(0, 20);
  const hasRepeatingChars = tripleRepeatingCharacterRegex.test(originalPassword);

  if (!hasRepeatingChars) {
    return originalPassword;
  }

  const splitPassword = originalPassword.split('');
  const passwordLength = splitPassword.length;
  let previousCharacter = null;
  let consecutiveReps = 1;
  for (let i = 0; i < passwordLength; i++) {
    const currentCharacter = splitPassword[i];
    consecutiveReps = currentCharacter === previousCharacter ? consecutiveReps + 1 : 1;
    if (consecutiveReps === MAX_REPEATING_CHARACTERS + 1) {
      const random = Math.floor(getRandomNumber() * specialCharacters.length);
      const randomSpecialCharacter = specialCharacters[random];
      splitPassword[i] = randomSpecialCharacter;
    }
    previousCharacter = currentCharacter;
  }

  return splitPassword.join('');
};
